module.exports = __webpack_public_path__ + "img/doorLogo11.1c8749a9.png";